import React from 'react';
import { useSelector } from 'react-redux';
import {
    Navigate,
    useLocation,
} from 'react-router-dom';

import { useAuth } from "../../common/hooks/useAuth";
import { Storage } from "../../common/utils/Storage";

import { selectLoginInCheckout, selectSettingsLoaded } from '../../common/store/settingsSlice';
import { selectIsLoadingUserLocations, selectUserHasLocations, selectUserLocationsFailed, selectUserLocationsNotRequested } from '../../common/store/locationsSlice';
import { UserLocationsLoadError } from './UserLocationsLoadError';

export const ProtectedRoute = ({ children }) => {
    const { token } = useAuth();
    const settingsLoaded = useSelector(selectSettingsLoaded);
    const loginOnlyInCheckout = useSelector(selectLoginInCheckout);
    const isLoadingUserLocations = useSelector(selectIsLoadingUserLocations);
    const userHasLocations = useSelector(selectUserHasLocations);
    const userLocationsFailed = useSelector(selectUserLocationsFailed);
    const userLocationsNotRequested = useSelector(selectUserLocationsNotRequested);
    const location = useLocation();

    const isIAMUser = Storage.isIAMUser();
    // IAM users load their locations only after the IAM login in LoginView completes
    const waitsForUserLocations = token && isLoadingUserLocations && !(isIAMUser && userLocationsNotRequested);

    if (!settingsLoaded || waitsForUserLocations) {
        return null;
    }

    if (token && userLocationsFailed) {
        return <UserLocationsLoadError />;
    }

    const hasCredentials = token && userHasLocations;
        
    if (!hasCredentials && !loginOnlyInCheckout) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    return children;
};
